import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { HttpClientModule } from '@angular/common/http';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { ListPage } from '../pages/list/list';
import { LoginPage } from '../pages/login/login';
import { AuthService } from '../providers/auth';
import { HttpModule } from '@angular/http';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { RidePage } from '../pages/ride/ride';
import { ThanksPage } from '../pages/thanks/thanks';
import { SignaturePage } from '../pages/signature/signature';
import { DetailPage } from '../pages/detail/detail';
import { SignaturePadModule } from 'angular2-signaturepad';
import { IonicStorageModule } from '@ionic/storage';
import { LaunchNavigator } from '@ionic-native/launch-navigator';
import { FileTransfer, FileUploadOptions, FileTransferObject } from '@ionic-native/file-transfer';
import { File } from '@ionic-native/file';
import { Camera } from '@ionic-native/camera';
import { Network } from '@ionic-native/network';
import { Geolocation } from '@ionic-native/geolocation';
//import { LocalNotifications } from '@ionic-native/local-notifications/ngx';
//import { AppUpdate } from '@ionic-native/app-update';

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    ListPage,
    LoginPage,
    RidePage,
    ThanksPage,
    DetailPage,
    SignaturePage,
  ],
  imports: [
    BrowserModule,
    HttpModule,
    SignaturePadModule,
    IonicStorageModule,
    IonicModule.forRoot(MyApp),
    HttpClientModule,

   
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    ListPage,
    LoginPage,
    RidePage,
    ThanksPage,
    DetailPage,
    SignaturePage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    AuthService,
    LaunchNavigator,
    //LocalNotifications,
    
    {provide: ErrorHandler, useClass: IonicErrorHandler},
     FileTransfer,
  //FileUploadOptions,
  //FileTransferObject,
  File,
  Camera,
  Network,
  Geolocation
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts